module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-panel",
    class: {
      'panelActive': this.selectedWeeks.length > 0 && this.deleteEvents
    }
  }, [(_vm.isLoading) ? _c('spinner') : [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessons.length === 0),
      expression: "lessons.length === 0"
    }]
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.noSubstitutesOrNotes')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lessons.length !== 0),
      expression: "lessons.length !== 0"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.youAreAboutToDelete')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lessons.length) + " " + _vm._s(_vm.lessons.length === 1 ? _vm.$t('vue2.copycalendar.lesson') : _vm.$t('vue2.copycalendar.lessons')) + " " + _vm._s(_vm.$t('vue2.copycalendar.withSubstitutesOrNotes')))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('ul', _vm._l((_vm.sortedLesson), function(lesson, index) {
    return _c('li', {
      key: lesson.id
    }, [(!_vm.isSameDate(index)) ? _c('p', {
      staticClass: "headline"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.copycalendar.week')) + " " + _vm._s(_vm._f("showWeek")(lesson.event_time_start)) + "\n        ")]) : _vm._e(), _vm._v(" "), (lesson.has_notes) ? _c('span', {
      staticClass: "icon-file-text2"
    }) : _vm._e(), _vm._v(" "), (lesson.has_substitute) ? _c('span', {
      staticClass: "icon-users"
    }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm._f("showDateAndTime")(lesson.event_time_start)) + "\n        " + _vm._s(lesson.title) + "\n      ")])
  }), 0)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03c38c9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendar/Feedback.vue
// module id = 1735
// module chunks = 1